export const HEARING_DIFFICULTY_OPTIONS = [
  { value: 'Peripheral (Medical) Hearing Loss', label: 'Peripheral (Medical) Hearing Loss' },
  {
    value: 'Auditory Processing Difficulties (APD-like features)',
    label: 'Auditory Processing Difficulties (APD-like features)',
  },
  { value: 'Hyperacusis (Sound Sensitivity)', label: 'Hyperacusis (Sound Sensitivity)' },
  {
    value: 'Hypersensitivity to Specific Frequencies',
    label: 'Hypersensitivity to Specific Frequencies',
  },
  { value: 'Auditory Filtering Difficulties', label: 'Auditory Filtering Difficulties' },
  { value: 'Delayed Auditory Processing', label: 'Delayed Auditory Processing' },
  { value: 'Fluctuating Hearing Issues', label: 'Fluctuating Hearing Issues' },
  { value: 'Other hearing issues', label: 'Other hearing issues' },
  { value: 'No hearing issues', label: 'No hearing issues' },
] as const;

export const VISION_DIFFICULTY_OPTIONS = [
  {
    value: 'Refractive Errors (Common in All Children)',
    label: 'Refractive Errors (Common in All Children)',
  },
  { value: 'Strabismus (Eye Alignment Problems)', label: 'Strabismus (Eye Alignment Problems)' },
  { value: 'Amblyopia (“Lazy Eye”)', label: 'Amblyopia (“Lazy Eye”)' },
  {
    value: 'Visual Processing Differences (Very Common in ASD)',
    label: 'Visual Processing Differences (Very Common in ASD)',
  },
  { value: 'Visual Sensory Sensitivities', label: 'Visual Sensory Sensitivities' },
  {
    value: 'Visual Attention & Scanning Differences',
    label: 'Visual Attention & Scanning Differences',
  },
  {
    value: 'Depth Perception & Binocular Vision Issues',
    label: 'Depth Perception & Binocular Vision Issues',
  },
  { value: 'Ocular Motor Dysfunction', label: 'Ocular Motor Dysfunction' },
  { value: 'Other vision issues', label: 'Other vision issues' },
  { value: 'No vision issues', label: 'No vision issues' },
] as const;

export const ASD_SEVERITY_OPTIONS = [
  { value: 'Level-1', label: 'Level-1' },
  { value: 'Level-2', label: 'Level-2' },
  { value: 'Level-3', label: 'Level-3' },
  { value: 'Unknown', label: 'Unknown' },
] as const;

export const CHILD_DELIVERY_TYPE_OPTIONS = [
  { value: 'Spontaneous', label: 'Spontaneous' },
  { value: 'C-Section', label: 'C-Section' },
  { value: 'Induced Vaginal', label: 'Induced Vaginal' },
  { value: 'Unknown', label: 'Unknown' },
] as const;

export const MEDICAL_DIAGNOSIS_OPTIONS = [
  { value: 'Adjustment Disorder (F43.2)', label: 'Adjustment Disorder (F43.2)' },
  { value: 'Anxiety (F41.9)', label: 'Anxiety (F41.9)' },
  { value: 'Asperger’s syndrome (F84.5)', label: 'Asperger’s syndrome (F84.5)' },
  {
    value: 'Attention-deficit hyperactivity disorder (F90.0, F90.1, F90.2, F90.8, F90.9)',
    label: 'Attention-deficit hyperactivity disorder (F90.0, F90.1, F90.2, F90.8, F90.9)',
  },
  { value: 'Cerebral Palsy (G80.9)', label: 'Cerebral Palsy (G80.9)' },
  { value: 'Cerebral Visual Impairment: (H47.61)', label: 'Cerebral Visual Impairment: (H47.61)' },
  { value: 'Coffin-Siris Syndrome (Q87.1)', label: 'Coffin-Siris Syndrome (Q87.1)' },
  { value: 'Congenital Heart Failure: (Q24.9)', label: 'Congenital Heart Failure: (Q24.9)' },
  { value: 'Depression (F33.0, F33.2)', label: 'Depression (F33.0, F33.2)' },
  {
    value: 'Developmental disorder of speech and language, unspecified (F80.9)',
    label: 'Developmental disorder of speech and language, unspecified (F80.9)',
  },
  {
    value: 'Disruptive mood dysregulation disorder (F34.81)',
    label: 'Disruptive mood dysregulation disorder (F34.81)',
  },
  { value: 'Downs Syndrome (Q90.9)', label: 'Downs Syndrome (Q90.9)' },
  {
    value: 'Emotional Disturbance Disorder (F98.9)',
    label: 'Emotional Disturbance Disorder (F98.9)',
  },
  { value: 'Epilepsy: (G40.0)', label: 'Epilepsy: (G40.0)' },
  {
    value: 'Generalized Anxiety Disorder (F41.1)',
    label: 'Generalized Anxiety Disorder (F41.1)',
  },
  { value: 'Global Speech Delay (F80)', label: 'Global Speech Delay (F80)' },
  {
    value: 'Mild Intellectual Developmental Disorder (F70)',
    label: 'Mild Intellectual Developmental Disorder (F70)',
  },
  {
    value: 'Mixed Receptive-Expressive Language Disorder (F80.2)',
    label: 'Mixed Receptive-Expressive Language Disorder (F80.2)',
  },
  { value: 'Obsessive Compulsive Disorder (F42)', label: 'Obsessive Compulsive Disorder (F42)' },
  {
    value: 'Oppositional Defiance Disorder (F91.3)',
    label: 'Oppositional Defiance Disorder (F91.3)',
  },
  { value: 'Oral Aversion (F50.82)', label: 'Oral Aversion (F50.82)' },
  {
    value: 'Other childhood disintegrative disorder (F84.3)',
    label: 'Other childhood disintegrative disorder (F84.3)',
  },
  {
    value: 'Other pervasive developmental disorders (F84.8)',
    label: 'Other pervasive developmental disorders (F84.8)',
  },
  { value: 'Pediatric Feeding Disorder (R63.32)', label: 'Pediatric Feeding Disorder (R63.32)' },
  {
    value: 'Pervasive developmental disorder, unspecified (F84.9)',
    label: 'Pervasive developmental disorder, unspecified (F84.9)',
  },
  {
    value: 'Post-Traumatic Stress Disorder (F43.12)',
    label: 'Post-Traumatic Stress Disorder (F43.12)',
  },
  { value: 'Prader-Willi Syndrome (Q87.11)', label: 'Prader-Willi Syndrome (Q87.11)' },
  { value: 'Rett’s syndrome (F84.2)', label: 'Rett’s syndrome (F84.2)' },
  { value: 'Sensory Processing Disorder (F88)', label: 'Sensory Processing Disorder (F88)' },
] as const;

export const EARLY_INTERVENTION_OPTIONS = [
  { value: 'Applied Behavior Analysis', label: 'Applied Behavior Analysis' },
  { value: 'Feeding Therapy', label: 'Feeding Therapy' },
  { value: 'Speech Therapy', label: 'Speech Therapy' },
  { value: 'Play Therapy', label: 'Play Therapy' },
  { value: 'Occupational Therapy', label: 'Occupational Therapy' },
  { value: 'Special Education Preschool', label: 'Special Education Preschool' },
  { value: 'Physical Therapy', label: 'Physical Therapy' },
  { value: 'Other', label: 'Other' },
  { value: 'None', label: 'None' },
] as const;

export const PREGNANCY_ISSUE_OPTIONS = [
  { value: 'Vaginal bleeding', label: 'Vaginal bleeding' },
  { value: 'Rh incompatibility', label: 'Rh incompatibility' },
  { value: 'Emotional problems', label: 'Emotional problems' },
  { value: 'Infections', label: 'Infections' },
  { value: 'Bed-rest', label: 'Bed-rest' },
  { value: 'Premature Labor', label: 'Premature Labor' },
  { value: 'Difficulty in conception', label: 'Difficulty in conception' },
  { value: 'Threatened miscarriage', label: 'Threatened miscarriage' },
  { value: 'Excessive swelling', label: 'Excessive swelling' },
  { value: 'Other virus', label: 'Other virus' },
  { value: 'Excessive nausea/vomiting', label: 'Excessive nausea/vomiting' },
  { value: 'Drug or Alcohol abuse', label: 'Drug or Alcohol abuse' },
  { value: 'Other', label: 'Other' },
  { value: 'None', label: 'None' },
] as const;

export const REGRESSION_OPTIONS = [
  { value: 'Speech language', label: 'Speech language' },
  { value: 'Gross motor', label: 'Gross motor' },
  { value: 'Fine motor', label: 'Fine motor' },
  { value: 'None', label: 'None' },
] as const;

export const MEDICAL_TEXT_MIN_LENGTH = 2;

export const MEDICAL_DIAGNOSIS_YEAR_BOUNDS = { min: 1900, max: 2100 } as const;

export const MEDICAL_NUMERIC_FIELD_BOUNDS = {
  f84_diagnosis_year: MEDICAL_DIAGNOSIS_YEAR_BOUNDS,
  child_gestational_age: { min: 0, max: 99 },
  child_weight_at_birth_pounds: { min: 0, max: 999 },
  child_weight_at_birth_ounces: { min: 0, max: 15 },
  child_sitting_up_age_months: { min: 0, max: 150 },
  child_crawling_age_months: { min: 0, max: 150 },
  child_walking_age_years: { min: 0, max: 30 },
  child_walking_age_months: { min: 0, max: 11 },
  child_standing_age_years: { min: 0, max: 30 },
  child_standing_age_months: { min: 0, max: 11 },
  child_babbling_age_months: { min: 0, max: 150 },
  child_first_words_age_months: { min: 0, max: 150 },
} as const;

export const SCREENING_DATES_REQUIRED_STATE = 'TX';

export const EMPTY_MEDICAL_INFO_VALUES = {
  allergies: '',
  special_diets: '',
  hearing_difficulty: '',
  hearing_screening_date: null,
  vision_difficulty: '',
  vision_screening_date: null,
  trauma_history: '',
  hospitalization_history: '',
  f84_severity_level: '',
  f84_diagnosis_provider_name: '',
  f84_diagnosis_city: '',
  f84_diagnosis_state: '',
  f84_diagnosis_year: '',
  child_delivery_type: '',
  child_gestational_age: '',
  child_weight_at_birth_pounds: '',
  child_weight_at_birth_ounces: '',
  child_sitting_up_age_months: '',
  child_crawling_age_months: '',
  child_walking_age_years: '',
  child_walking_age_months: '',
  child_standing_age_years: '',
  child_standing_age_months: '',
  child_babbling_age_months: '',
  child_first_word: '',
  child_second_word: '',
  child_first_words_age_months: '',
} as const;

export const EMPTY_MEDICAL_DIAGNOSIS_VALUES = {
  diagnosis_name: '',
  diagnosis_provider_name: '',
  diagnosis_city: '',
  diagnosis_state: '',
  diagnosis_year: '',
} as const;

// Scalar field names whose form value is a Moment (date) — used by the save-on-blur helpers.
export const MEDICAL_INFO_DATE_FIELD_NAMES = [
  'hearing_screening_date',
  'vision_screening_date',
] as const;

// Scalar field names whose form value is a numeric string — converted to integer in the payload.
export const MEDICAL_INFO_NUMERIC_FIELD_NAMES = [
  'f84_diagnosis_year',
  'child_gestational_age',
  'child_weight_at_birth_pounds',
  'child_weight_at_birth_ounces',
  'child_sitting_up_age_months',
  'child_crawling_age_months',
  'child_walking_age_years',
  'child_walking_age_months',
  'child_standing_age_years',
  'child_standing_age_months',
  'child_babbling_age_months',
  'child_first_words_age_months',
] as const;

// All scalar field names (drives change-diffing in the save-on-blur hook).
export const MEDICAL_INFO_FIELD_NAMES = [
  'allergies',
  'special_diets',
  'hearing_difficulty',
  'hearing_screening_date',
  'vision_difficulty',
  'vision_screening_date',
  'trauma_history',
  'hospitalization_history',
  'f84_severity_level',
  'f84_diagnosis_provider_name',
  'f84_diagnosis_city',
  'f84_diagnosis_state',
  'f84_diagnosis_year',
  'child_delivery_type',
  'child_gestational_age',
  'child_weight_at_birth_pounds',
  'child_weight_at_birth_ounces',
  'child_sitting_up_age_months',
  'child_crawling_age_months',
  'child_walking_age_years',
  'child_walking_age_months',
  'child_standing_age_years',
  'child_standing_age_months',
  'child_babbling_age_months',
  'child_first_word',
  'child_second_word',
  'child_first_words_age_months',
] as const;
